export const filterFalsyValues = (data) =>
  Object.fromEntries(
    Object.entries(data).filter((field) =>
      typeof field[1] === "string" ? !!field[1].trim() : !!field[1]
    )
  );
